(function() {
  var JUNIP_INPUT_SELECTOR = '.junip-product-review input[id], .junip-product-review-container input[id], .junip-review-section input[id], #review_scroll input[id]';

  function escapeId(id) {
    if (typeof CSS !== 'undefined' && CSS.escape) {
      return CSS.escape(id);
    }
    return id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getJunipInputs() {
    return Array.prototype.slice.call(document.querySelectorAll(JUNIP_INPUT_SELECTOR));
  }

  function findLabelForInput(input, forId) {
    var label = input.closest('label');
    if (label) {
      return label;
    }

    var parent = input.parentElement;
    while (parent) {
      var labels = parent.querySelectorAll('label[for="' + escapeId(forId) + '"]');
      for (var i = 0; i < labels.length; i++) {
        if (!labels[i].dataset.junipA11yFor || labels[i].dataset.junipA11yFor === forId) {
          var labelInput = parent.querySelector('#' + escapeId(forId));
          if (labelInput === input) {
            return labels[i];
          }
        }
      }
      if (parent.matches && parent.matches('.junip-product-review-container, .junip-product-review, .junip-review-section, #review_scroll')) {
        break;
      }
      parent = parent.parentElement;
    }

    var container = input.closest('.junip-checkbox, .junip-product-review-container, .junip-product-review, #review_scroll');
    if (container) {
      var localLabels = container.querySelectorAll('label[for="' + escapeId(forId) + '"]');
      for (var j = 0; j < localLabels.length; j++) {
        if (!localLabels[j].dataset.junipA11yFor) {
          return localLabels[j];
        }
      }
    }

    return null;
  }

  function fixDuplicateInputIds() {
    var inputs = getJunipInputs();
    if (!inputs.length) {
      return;
    }

    var groups = {};

    inputs.forEach(function(input) {
      if (!input.id) {
        return;
      }
      if (!groups[input.id]) {
        groups[input.id] = [];
      }
      groups[input.id].push(input);
    });

    Object.keys(groups).forEach(function(id) {
      var group = groups[id];
      if (group.length < 2) {
        return;
      }

      group.forEach(function(input, index) {
        if (index === 0) {
          return;
        }

        var newId = id + '-dup-' + index;
        var label = findLabelForInput(input, id);

        input.id = newId;

        if (label) {
          label.setAttribute('for', newId);
          label.dataset.junipA11yFor = newId;
        }
      });
    });
  }

  function observeJunipContent() {
    fixDuplicateInputIds();

    var observer = new MutationObserver(function() {
      fixDuplicateInputIds();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeJunipContent);
  } else {
    observeJunipContent();
  }
})();
